import React from 'react';

export default function RemoveCircleIcon({as = React.Fragment, Tag = as, ...props}) {
  return (
    <Tag {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="icon-remove-circle"><circle cx="12" cy="12" r="10" className="primary"/><rect width="12" height="2" x="6" y="11" className="secondary" rx="1"/></svg>
    </Tag>
  )
};
